//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"LinearSliderVector",1,"Direction",0],[0,"Name",1,0],[0,"PlanarSliderPlane",1,"Plane",0],[1,"SelectFace",0,"ScCollector",0],[1,"Temperature",0,"Expression",0],[1,"ThickenOffset",0,"Expression",0],[0,"Type",1,0],[0,"UserSetName",1,0]],[[[],"UpdateDisplay",{},0,0]],[]];
SPLM.DesignSimulation.AnalysisConstraintBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.AnalysisConstraintBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.AnalysisConstraintBuilder.ConstraintType = Object.freeze({
    "Fixed" : "Fixed", "Pinned" : "Pinned", "PinnedSlider" : "PinnedSlider", "LinearSlider" : "LinearSlider", "PlanarSlider" : "PlanarSlider", "Temperature" : "Temperature"});

export default SPLM;